"use client"

import { trackAppRouter } from "@socialgouv/matomo-next"
import { usePathname, useSearchParams } from "next/navigation"
import { useEffect } from "react"

import { MATOMO_SITE_ID, MATOMO_URL } from "@/src/config/analytics"
import { trackClientEvent } from "@/src/lib/analytics/client"
import { ANALYTICS_ACTIONS, ANALYTICS_CATEGORIES, ANALYTICS_EVENT_NAMES } from "@/src/lib/analytics/events"

export function MatomoAnalytics() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (!pathname) {
      return
    }

    trackAppRouter({
      url: MATOMO_URL,
      siteId: MATOMO_SITE_ID,
      pathname,
      searchParams,
      disableCookies: true,
      cleanUrl: true,
    })

    trackClientEvent({
      category: pathname.startsWith("/app") ? ANALYTICS_CATEGORIES.AUTH_NAV : ANALYTICS_CATEGORIES.PUBLIC_NAV,
      action: ANALYTICS_ACTIONS.VIEW,
      name: pathname.startsWith("/app")
        ? ANALYTICS_EVENT_NAMES.PAGE_VIEW_AUTH
        : ANALYTICS_EVENT_NAMES.PAGE_VIEW_PUBLIC,
      metadata: {
        path: pathname,
      },
    })
  }, [pathname, searchParams])

  return null
}
